import { styled } from '@mui/material/styles'
import Badge from '@mui/material/Badge'

const PREFIX = 'FavoriteMenu'

export const badgeClasses = {
  root: `${PREFIX}-root`,
  badge: `${PREFIX}-badge`,
  iconButton: `${PREFIX}-iconButton`,
  iconButtonText: `${PREFIX}-iconButtonText`,
  iconContainer: `${PREFIX}-iconContainer`,
}

export const modalClasses = {
  title: `${PREFIX}-title`,
  actionItemsContainer: `${PREFIX}-actionItemsContainer`,
  favoritesList: `${PREFIX}-favoritesList`,
  actionButtonRow: `${PREFIX}-actionButtonRow`,
  actionButton: `${PREFIX}-actionButton`,
}

export const StyledBadge = styled(Badge)(({ theme }) => ({
  [`& .${badgeClasses.root}`]: {
    position: 'relative',
  },

  [`& .${badgeClasses.badge}`]: {
    borderRadius: '50%',
    marginTop: 11,
    marginRight: 20,
  },

  [`& .${badgeClasses.iconButton}`]: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingRight: 8,
    paddingLeft: 8,
  },

  [`& .${badgeClasses.iconButtonText}`]: {
    fontSize: 10,
  },

  [`& .${badgeClasses.iconContainer}`]: {
    '& svg': {
      width: 30,
      height: 30,
    },
    paddingTop: 3,
  },
}))

export const ModalStyles = styled('div')(({ theme }) => ({
  [`& .${modalClasses.title}`]: {
    padding: 16,
  },

  [`& .${modalClasses.actionItemsContainer}`]: {
    paddingTop: 16,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },

  [`& .${modalClasses.favoritesList}`]: {
    width: '90%',
    maxHeight: '40%',
    marginLeft: 16,
    maxWidth: 360,
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    backgroundColor: theme.palette.background.paper,
  },

  [`& .${modalClasses.actionButtonRow}`]: {
    display: 'flex',
    width: '90%',
  },

  [`& .${modalClasses.actionButton}`]: {
    flexGrow: 1,
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}))
